import React, { useEffect, useState } from "react"
import { Form, Modal } from "antd"
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import api from "./api"
import { useTranslation } from "react-i18next"
import {setFormErrors} from "../../../helpers/formErrors";

const ReStandardsDeterminantsChangeForm = (props) => {
	const [loading, setLoading] = useState(false)
	const { visible, setVisible, setRecord, record, changed } = props
	const {t} = useTranslation(['common', 'valid', 'action'])
	const [form] = Form.useForm()

	const create = params => {
		action(api.create, params, changed, t('action:created'))
	}
	const update = params => {
		action(api.update, params, changed, t('action:updated'))
	}

	const action = (func, params, sucFunction, sucParams) => {
		setLoading(true)
		func(params)
			.then(res => sucFunction(res, sucParams))
			.catch(err => {
				setFormErrors(err, form)
			})
			.finally(() => setLoading(false))
	}

	useEffect(() => {
		form.resetFields()
		if (record) {
			form.setFieldsValue({
				code   : record.code,
				name   : record.name,
               	})
		}
	}, [record])



	function handleCancel(){
		form.resetFields()
		setRecord(null)
		setVisible(false)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id         : record?.id,
				code       : values.code,
				name       : values.name.trim(),
				createDate : record?.createDate,
              	isDeleted  : record?.isDeleted
			}
			const previousValues = {
				id         : record?.id,
				code       : record?.code,
				name       : record?.name,
				createDate : record?.createDate,
				isDeleted  : record?.isDeleted
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice(t('valid:sameData'), null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnHidden
			footer={[
				<CustomButton
					key="save"
					loading={loading}
					type="green"
					onClick={save}
				>
					{t('action:save')}
				</CustomButton>
			]}
			title={record ? t('action:editRecord') : t('action:addRecord')}
			open={visible}
			width={900}
			onCancel={handleCancel}
		>
			<Form
				form={form}
				labelAlign="left"
				labelCol={{span: 6}}
				name="nsi-form"
				wrapperCol={{span: 17, offset: 1}}
			>
				<Form.Item
					label={t('common:code')}
					name="code"
					rules={[
						{
							required   : true,
							whitespace : true,
							message    : t('valid:codeFilledBad'),
							pattern    : /^[1-9]\d{0,6}$/
						}
					]}
				>
					<CustomInput
					    disabled = {record}
						placeholder={`${t('action:enter')} ${t('common:code').toLowerCase()}`}
					/>
				</Form.Item>
				
				<Form.Item
					label={t('common:title')}
					name="name"
					rules={[
						{
							required   : true,
							whitespace : true,
							min        : 3,
							max        : 200
						}
					]}
				>
					<CustomInput
						maxLength={ 250 }
						placeholder={`${t('action:enter')} ${t('common:title').toLowerCase()}`}
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ReStandardsDeterminantsChangeForm